module.exports = __webpack_public_path__ + "img/symbol_7.f7b7da18.png";